module.exports = __webpack_public_path__ + "img/logo_skolkovo-white.7a1f9aa0.svg";